import { render } from "./indexbanner.vue?vue&type=template&id=f25618a6"
import script from "./indexbanner.vue?vue&type=script&lang=js"
export * from "./indexbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__